import { useEffect, useState } from 'react';
import api from '@/lib/api';

interface AuditLog {
  id: string;
  userName: string;
  action: string;
  entity: string;
  entityId: string;
  ipAddress: string;
  createdAt: string;
}

const actionLabels: Record<string, { label: string; color: string }> = {
  CREATE: { label: 'Criar', color: 'bg-green-100 text-green-700' },
  UPDATE: { label: 'Atualizar', color: 'bg-blue-100 text-blue-700' },
  DELETE: { label: 'Excluir', color: 'bg-red-100 text-red-700' },
  LOGIN: { label: 'Login', color: 'bg-purple-100 text-purple-700' },
  LOGOUT: { label: 'Logout', color: 'bg-gray-100 text-gray-700' },
};

export default function AuditPage() {
  const [logs, setLogs] = useState<AuditLog[]>([]);
  const [loadingData, setLoadingData] = useState(true);

  useEffect(() => {
    api.get('/audit').then((r) => {
      setLogs(r.data.data || r.data);
      setLoadingData(false);
    }).catch(() => setLoadingData(false));
  }, []);

  return loadingData ? (
    <div className="flex items-center justify-center h-64">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
    </div>
  ) : (
    <div className="bg-white rounded-xl shadow-sm border border-dark-100 overflow-hidden">
      <table className="w-full">
        <thead className="bg-dark-50">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-dark-500 uppercase">Usuario</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-dark-500 uppercase">Acao</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-dark-500 uppercase">Entidade</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-dark-500 uppercase">ID Entidade</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-dark-500 uppercase">IP</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-dark-500 uppercase">Data</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-dark-100">
          {logs.map((log, index) => (
            <tr key={log.id} className={index % 2 === 0 ? 'bg-white' : 'bg-dark-50/50'}>
              <td className="px-6 py-4 text-sm font-medium text-dark-900">{log.userName || '-'}</td>
              <td className="px-6 py-4">
                <span className={`px-2.5 py-1 text-xs font-medium rounded-full ${actionLabels[log.action]?.color || 'bg-gray-100 text-gray-700'}`}>
                  {actionLabels[log.action]?.label || log.action}
                </span>
              </td>
              <td className="px-6 py-4 text-sm text-dark-600">{log.entity}</td>
              <td className="px-6 py-4 text-sm text-dark-500 font-mono">{log.entityId || '-'}</td>
              <td className="px-6 py-4 text-sm text-dark-500 font-mono">{log.ipAddress || '-'}</td>
              <td className="px-6 py-4 text-sm text-dark-500">
                {new Date(log.createdAt).toLocaleDateString('pt-BR')} {new Date(log.createdAt).toLocaleTimeString('pt-BR')}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {logs.length === 0 && (
        <div className="text-center py-12 text-dark-500">Nenhum registro de auditoria</div>
      )}
    </div>
  );
}
